type Width = "FULL" | "HALF";

export const ComponentsWidth: Record<Width, 50 | 100> = {
  HALF: 50,
  FULL: 100
};
